import React from 'react';
import { get } from 'lodash-es';
import { Form } from 'informed';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import NavBreadCrumb from '../../containers/NavBreadCrumb';
import { InputSelect } from '../../components/inputs';
import InputSummernote from '../../components/inputs/InputSummernote';
import FormContainer from '../../containers/Form';
import { BaseForm } from '../../base';
import { API_HOST } from '../../consts';
import ItemConteudo from '../../components/ItemConteudo';
import FileList from '../../components/FileList';
import moment from 'moment';

const mapStatus = (s) => ({
  value: s.id,
  label: s.descricao
});

class RecursoFormElaborador extends BaseForm {
  constructor(props) {
    super(props);
    this.id = get(this.props, 'match.params.id');
  }

  state = {
    recurso: [],
    itens: [],
    status: []
  };

  componentDidMount() {
    this.fetchStatus();
    this.fetchRecurso();
    this.fetchMetadata();
  }

  fetchRecurso() {
    axios.get(`${API_HOST}/recursos/recurso/${this.id}`).then((response) => {
      this.setState({ recurso: response.data });
      const { aplicacao, requerente, nome_requerente, status, ...values } =
        response.data;
      this.setState({ recursos: response.data });
      this.formApi.setValues(values);
      this.fetchItens(response.data.item);
    });
  }

  fetchItens = (value) => {
    axios.get(`${API_HOST}/itens/item/${value}`).then((response) => {
      const itens = response.data;
      this.setState({ itens });
    });
  };

  fetchStatus() {
    return axios.get(`${API_HOST}/recursos/status`).then((response) => {
      this.setState({
        status: response.data.map(mapStatus)
      });
    });
  }

  getCurrentPath() {
    return this.id === 'new' ? 'Novo recurso' : ` Atender recurso ${this.id}`;
  }

  handleSubmit = () => {
    const { formState, recurso } = this.state;
    const { values } = formState;

    axios
      .patch(
        `${API_HOST}/recursos/recurso/${this.id}/update_julgamento`,
        values
      )
      .then(() => {
        const { history } = this.props;
        toast.success('Recurso atendido com sucesso.');
        history.push('/recursos');
      })
      .catch(this.onValidateError);
  };

  render() {
    const { status, itens, recursos } = this.state;
    const pathList = [
      {
        label: 'Recursos',
        link: '/recursos'
      }
    ];

    return (
      <React.Fragment>
        <NavBreadCrumb
          pathList={pathList}
          currentPath={this.getCurrentPath()}
        />

        <div className="container pb-5">
          <FormContainer
            title="Dados do Recurso"
            last="/recursos"
            onClick={this.handleSubmit}
          >
            <div className="row">
              <div className="col-md-8">
                <p>
                  <strong>Avaliação:</strong>
                </p>
                <p>{get(recursos, 'aplicacao.nome')}</p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <p>
                  <strong>Data do envio:</strong>
                </p>
                <p>{get(recursos, 'data')}</p>
              </div>
              <div className="col-md-4">
                <p>
                  <strong>Data limite para resposta:</strong>
                </p>
                <p>{get(recursos, 'data_limite') ? moment(get(recursos, 'data_limite')).format('DD/MM/YYYY') : '-'}</p>
              </div>
            </div>
            <hr />
            <div className="container pb-5">
              <ItemConteudo item={itens} />
            </div>
            <hr />
            <label>Anexos</label>
            <FileList
              files={get(recursos, 'anexos')}
              timestamp={false}
              preview={false}
            />
            <hr />
            <div className="row">
              <div className="col-md-12">
                <p>
                  <strong>Justificativa e Bibliografia</strong>
                </p>
                <p
                  dangerouslySetInnerHTML={{
                    __html: get(recursos, 'justificativa')
                  }}
                ></p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <p>
                  <strong>Mensagem para o elaborador</strong>
                </p>
                <p
                  dangerouslySetInnerHTML={{
                    __html: get(recursos, 'mensagem_elaborador')
                  }}
                ></p>
              </div>
            </div>
            <hr />
            <Form
              onChange={(formState) => this.setState({ formState })}
              getApi={(formApi) => {
                this.formApi = formApi;
              }}
            >
              <React.Fragment>
                <div className="row">
                  <InputSelect
                    required={this.isRequired('recurso.status')}
                    col="col-sm-8"
                    label="Estado do Recurso"
                    field="status"
                    options={status}
                  />
                </div>
                <hr />

                <InputSummernote
                  required={this.isRequired('recurso.julgamento')}
                  col="col-sm-12"
                  label="Julgamento"
                  field="julgamento"
                />
                <InputSummernote
                  required={this.isRequired('recurso.medida')}
                  col="col-sm-12"
                  label="Medida"
                  field="medida"
                />
              </React.Fragment>
            </Form>
          </FormContainer>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(RecursoFormElaborador);
